import React from 'react'
import { FormTxt } from 'atoms/Inputs'
import { DatePickerContainer, StyledDatePicker, StyledMonthPicker } from './styles'
import moment from 'moment'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

const CustomInput = ({ value, onClick, config }) => (
  <FormTxt
    value={moment(value).calendar()}
    onClick={onClick}
    onChangeVal={e => null}
    readonly
    {...config}
  />
);

const CustomDateTimeInput = ({ value, onClick, config }) => (
  <FormTxt
    value={value ? moment(value).format('DD-MMM-YYYY HH:mm') : 'Select Date'}
    mb={'16px'}
    onClick={onClick}
    onChangeVal={e => null}
    readonly
    {...config}
  />
);

const CustomDateInput = ({ value, onClick, config, format }) => (
  <FormTxt
    value={moment(value).format(format || 'DD/MM/YYYY')}
    onClick={onClick}
    onChangeVal={e => null}
    readonly
    {...config}
  />
);

const CustomTimeInput = ({ value, onClick, config }) => (
  <FormTxt
    value={value || 'Select time'}
    onClick={onClick}
    onChangeVal={e => null}
    readonly
    {...config}
  />
);

const CustomFormatDateInputTxt = ({ value, onClick, config, format }) => {
  const periodeFormat = (value && format === 'periode_format') ? `(1-${moment(value).format("D")}) ${moment(value).format("MMM")} ${moment(value).format("YYYY")}` : null;
  
  return (<FormTxt
    value={value ? periodeFormat || moment(value).format(format || 'DD/MM/YYYY') : 'Select date'}
    onClick={onClick}
    onChangeVal={e => null}
    readonly
    {...config}
  />)
};

export const DateTimeInput = ({ val, fn, field, config, showTime }) => {
  return (
    <div className={'col-12 px-0'}>
      <StyledDatePicker
        selected={val}
        onChange={date => fn(date, field)}
        timeInputLabel="Enter Time"
        dateFormat="MM/dd/yyyy h:mm aa"
        showTimeInput={showTime}
        customInput={showTime ? <CustomDateTimeInput config={config} /> : <CustomInput config={config} />}
      />
    </div>
  )
}

export const DateInput = ({ val, fn, field, config }) => {
  return (
    <div className={'col-12 px-0'}>
      <StyledDatePicker
        selected={val}
        onChange={date => fn(date, field)}
        dateFormat="MM/dd/yyyy"
        customInput={<CustomDateInput config={config} />}
      />
    </div>
  )
}

export const TimeInput = ({ val, fn, field, config }) => {
  return (
    <div className={'col-12 px-0'}>
      <StyledDatePicker
        selected={val}
        onChange={date => fn(date, field)}
        timeCaption="Time"
        dateFormat="h:mm aa"
        showTimeInput
        showTimeSelectOnly
        customInput={<CustomTimeInput config={config} />}
      />
    </div>
  )
}

export const MonthYearInput = ({ val, fn, field, config }) => {
  return (
    <div className={'col-12 px-0'}>
      <StyledMonthPicker
        wrapperClassName="w-100"
        selected={val}
        onChange={date => fn(date, field)}
        showMonthYearPicker
        fullWidth
        customInput={<CustomDateInput format={'MMM YYYY'} config={config} />}
      />
    </div>
  )
}

export const CustomFormatDateInput = ({ val, fn, field, config, dateFormat, maxDate, minDate, disabled }) => {
  return (
    <div className={'col-12 px-0'}>
      <DatePickerContainer>
        <DatePicker
          maxDate={maxDate}
          minDate={minDate}
          selected={val}
          onChange={date => fn(date, field)}
          dateFormat="MM/dd/yyyy"
          customInput={<CustomFormatDateInputTxt config={config} format={dateFormat} />}
          disabled={disabled}
        />
      </DatePickerContainer>
    </div>
  )
}

export const TimeInputTwoVersion = ({ val, fn, field, config, disabled=false, minTime=new Date(), maxTime=new Date() }) => {
  return (
    <div className={'col-12 px-0'}>
      <DatePickerContainer>
        <DatePicker
          selected={val}
          onChange={date => fn(date, field)}
          timeCaption="Time"
          timeFormat="HH:mm"
          dateFormat="h:mm aa"
          showTimeSelect
          showTimeSelectOnly
          customInput={<CustomTimeInput config={config} />}
          disabled={disabled}
          minTime={minTime}
          maxTime={maxTime}
          timeIntervals={1}
        />
      </DatePickerContainer>
    </div>
  )
}